let accordionBoxElementAttr = 'data-accordion';
let animationDuration = 300;
let scrollDuration = 300;
let openClass = 'open';
let openClassAtInit = 'js-collapsed';
let noTransitionClass = 'no-transition';
let activeContentClass = 'accordion-active-content';
let $fixedCompensateElement = $('.js-accordion-compensate-scroll');
let $header = $('.header');

hashAutoOpenAddClass();
createAccordions();

// Инизиализация на родительском элементе, открытие/скрытие последующих элементов за кнопками
function createAccordions() {
	
	inicialAccordions();
	
	function inicialAccordions() {
		
		var $accordionBoxes = $('[' + accordionBoxElementAttr + ']');
		
		$accordionBoxes.each(function (i, el) {
			
			var $box = $(el);
			
			var accordionOptions = {
				header: getHeaderAccordion,
				classes: {
					"ui-accordion-header-active": openClass,
				},
				active: getActiveElementAccordion($box),
				collapsible: true,
				icons: false,
				heightStyle: 'content',
				animate: animationDuration,
				beforeActivate: function (event, ui) {
					scrollDirDisable();
					fixBlinkBugIE11(event, ui);
					// updateRangeSlider(event, ui);
					removeActiveClass(event, ui);
					scrollToActiveElement(event, ui);
				},
				activate: function (event, ui) {
					scrollDirEnable();
					addActiveClass(event, ui);
					clearHash(event, ui);
					window.dispatchEvent(new Event('resize'));
				},
				create: function(){
					removeNoTransitionClass($box);
					hashAutoOpen($box);
				},
			};
			
			$box.accordion(accordionOptions);
			
			watchCSS($box);
			
		});
		
		// Исправление моргания перед анимацией в IE 11
		function fixBlinkBugIE11(event, ui) {
			
			var $newPanel = ui.newPanel;
			var $oldPanel = ui.oldPanel;
			
			setTimeout(function () {
				$oldPanel.removeClass('z-inactive');
			}, animationDuration);
			
			setTimeout(function () {
				$newPanel.addClass('z-visible');
				
				setTimeout(function () {
					$newPanel.removeClass('z-visible');
					$newPanel.addClass('z-inactive');
				}, animationDuration);
				
			}, 0);
			
		}
		
		// Исправление проблемы прыгающего range slider при открытии accordion
		function updateRangeSlider(event, ui) {
			
			var rangeSlider = ui.newPanel.find($rangeSliderElements);
			
			if (rangeSlider.length > 0) {
				
				var instance = rangeSlider.data('ionRangeSlider');
				
				setTimeout(function () {
					instance.updateScene()
				}, 0);
				
			}
			
		}
		
		function addActiveClass(event, ui) {
			
			var $box = $(event.target);
			
			$box.find('.' + activeContentClass).removeClass(activeContentClass);
			
			if (ui.newPanel.length) {
				ui.newPanel.addClass(activeContentClass);
			}
			
		}
		
		function removeActiveClass(event, ui) {
			
			if (ui.newPanel.length === 0) {
				
				ui.oldPanel.removeClass(activeContentClass);
				
			}
			
		}
		
		function removeNoTransitionClass($box) {
			
			$box.find('.' + noTransitionClass).removeClass(noTransitionClass);
			
		}
		
		function scrollToActiveElement(event, ui) {
			
			if (!$.isEmptyObject(ui.newHeader.offset())) {
				
				var $el = ui.newHeader;
				var headerHeight = $header.height();
				var $scrollElement = $el.scrollParent();
				var isScrollDocument = $scrollElement.is(document);
				var oldPannelHeight = ui.oldPanel.height();
				var newUnderOld = getNewUnderOld();
				
				var withinviewportSettings = {
					top: (isScrollDocument ? headerHeight : 0) + oldPannelHeight,
					container: $scrollElement[0],
				};
				
				var elementIsViewport = $el.withinviewport(withinviewportSettings).length > 0;
				
				if (newUnderOld) {
					
					var paddingTop = 0;
					// paddingTop = -10; // дополнительный визуальный отступ от шапки
					
					//region Компепенсация фиксированного элемента в попапе
					var fixedCompensateElement = $('.fancybox-content').find($fixedCompensateElement);
					var fixedCompensate = 0;
					
					if (fixedCompensateElement.length === 1) {
						
						var fixedCompensateElementHeight = fixedCompensateElement.height();
						fixedCompensate = fixedCompensateElementHeight;
						
					}
					//endregion
					
					// если шапка зафиксирована, то учитываем это
					if (isScrollDocument && headerHeight) {
						paddingTop -= headerHeight;
					}
					
					var scrollPosition = 0;
					var $animateElement = '';
					
					
					if (isScrollDocument) {
						$animateElement = $('html, body');
						scrollPosition = ($el.offset().top - oldPannelHeight) + paddingTop;
					} else {
						$animateElement = $scrollElement;
						scrollPosition = $el[0].offsetTop - oldPannelHeight - fixedCompensate;
					}
					
					$animateElement.stop().animate({scrollTop: scrollPosition}, scrollDuration);
				}
				
			}
			
			function getNewUnderOld() {
				
				if (ui.oldHeader.length && ui.newHeader.length) {
					
					var $commonParent = getCommonParent(ui.oldHeader, ui.newHeader);
					var $childrens = $commonParent.children();
					var oldIndex = $commonParent.find(ui.oldHeader).closest($childrens).index();
					var newIndex = $commonParent.find(ui.newHeader).closest($childrens).index();
					
					var newUnderOld = oldIndex < newIndex;
					
					return newUnderOld;
					
				} else {
					return false;
				}
				
			}
			
		}
		
	}
	
	function getHeaderAccordion($box) {
		
		var headerItemSelector = $box.attr(accordionBoxElementAttr);
		
		return $box.find(headerItemSelector).filter(function (i, el) {
			
			var $el = $(el);
			$el.addClass(noTransitionClass);
			
			// Оставляем ссылки кликабельными, когда за ними нет раскрывающийся элемента
			if ($el.next().length == 1) {
				return true;
			} else {
				return false;
			}
			
		});
		
	}
	
	function getActiveElementAccordion($box) {
		
		var index = false;
		var headerItemSelector = $box.attr(accordionBoxElementAttr);
		
		if ($box.find('.' + openClassAtInit).length) {
			index = $box.find('.' + openClassAtInit).closest(headerItemSelector).index();
			
			$box.find(headerItemSelector).each(function (i, el) {
				if ($(el).hasClass(openClassAtInit)) {
					
					$(el).next().addClass('z-inactive');
					
					index = i;
					return false;
					
				}
			});
			
		}
		
		return index;
		
	}
	
}

// Возможность отключать и включать аккордеон через CSS
function watchCSS($box, options) {
	
	var runWatchCSS = function () {
		if ($box.length == 1) {
			
			var afterContent = getComputedStyle($box[0], ':after').content;
			var isDisable = afterContent.indexOf('accordion-disable') != -1;
			
			if (isDisable) {
				if ($box.hasClass('ui-accordion')) {
					var optionsAccordeon = $box.accordion("option");
					$box.data('options-accordeon', optionsAccordeon);
					$box.accordion("destroy");
				}
			} else {
				if (!$box.hasClass('ui-accordion')) {
					var optionsAccordeon = $box.data('options-accordeon');
					$box.accordion(optionsAccordeon);
				}
			}
			
		}
	}
	
	runWatchCSS();
	
	$(document).on('afterShow.fb', function (e, instance, slide) {
		runWatchCSS();
	});
	
	window.addEventListener("resize", runWatchCSS);
	
}

function getCommonParent($el, $el2) {
	return $el.parents().has($el2).first();
}

function hashAutoOpen($box) {
	
	let headerItemSelector = $box.attr(accordionBoxElementAttr);
	let $lements = $box.find(headerItemSelector);
	
	$(window).on('hashchange', function (e) {
		
		let id = window.location.hash.replace('#', '');
		let $target = $lements.filter('[data-accordion-id="'+id+'"]');
		
		if($target.length === 1) {
			$target.click();
		}
		else {
			$lements.filter('.' + openClass).click();
		}
		
	});
	
	
}

function hashAutoOpenAddClass() {
	
	let id = window.location.hash.replace('#','');
	let anchor = $('[data-accordion-id="'+id+'"]');
	
	if(anchor.length === 1) {
		anchor.addClass(openClassAtInit);
	}
	
}

function clearHash(event, ui) {
	
	if(ui.newPanel.length === 0) {
		history.replaceState("", document.title, window.location.pathname + window.location.search);
	}
	else {
		let id = ui.newHeader.attr('data-accordion-id');
		history.replaceState("", document.title, window.location.pathname + window.location.search + '#' + id);
	}
	
}

function scrollDirDisable() {
	let attrDir = $('html').attr('data-scrolldir');
	scrollDir({ off: true });
	$('html').attr('data-scrolldir', attrDir);
}

function scrollDirEnable() {
	let attrDir = $('html').attr('data-scrolldir');
	scrollDir({ off: false });
	$('html').attr('data-scrolldir', attrDir);
}